import { AxiosError } from 'axios';
import React from 'react';
import { Box, ErrorStateInfo, Grid, Typography } from 'web-library';
import { UploadedFile } from 'web-library/models/UploadedFile';
import { PutUploadFileToS3Request } from '../../../../api-refactored/s3-upload/usePutUploadFileToS3';
import { GenericErrorResponse } from '../../../../api-refactored/typings';
import { UseCustomMutationReturn } from '../../../../api-refactored/utils/useCustomMutation';
import { FileUploadState } from '../../../../models/File';
import { RequestFileDropZone } from '../../../../components/access-configuration/RequestFileDropZone';
import { useGetBulkListExcelFileConfigs } from '../../../../api-refactored/user-group-access-configuration/useGetBulkListExcelConfigs';

interface IDocumentUploader {
  classes: any;
  translation: any;
  showUploadInstruction: boolean;
  fileStatus?: FileUploadState;
  apiHooks: {
    uploadMutation: UseCustomMutationReturn<
      void,
      AxiosError<GenericErrorResponse>,
      PutUploadFileToS3Request,
      unknown
    >;
  };
  stateHandler: {
    setUploadedFileHandler: {
      uploadedFiles: UploadedFile[];
      setUploadedFiles: React.Dispatch<React.SetStateAction<UploadedFile[] | []>>;
    };
  };
}

const DocumentUploader = ({
  classes,
  translation: t,
  apiHooks,
  stateHandler,
  showUploadInstruction,
  fileStatus,
}: IDocumentUploader) => {
  const { isError: isUploadError } = apiHooks.uploadMutation;
  const { uploadedFiles, setUploadedFiles } = stateHandler.setUploadedFileHandler;

  const { data: requestFilesConfigData } = useGetBulkListExcelFileConfigs({});

  return (
    <>
      {(isUploadError || fileStatus === FileUploadState.FAILED) && (
        <Box className={classes.uploadErrorSection}>
          <Typography variant="body1" className={classes.description}>
            {t('exam->>UploadExcelTemplate.UploadErrorInstruction')}
          </Typography>
          <ErrorStateInfo>
            <Typography variant="body1" className={classes.uploadErrorDescription}>
              {t('exam->>UploadExcelTemplate.UploadErrorDescription')}
            </Typography>
          </ErrorStateInfo>
        </Box>
      )}
      {!isUploadError && showUploadInstruction && (
        <Typography variant="body1" className={classes.description}>
          {t('exam->>UploadExcelTemplate.UploadDocumentsDescription')}
        </Typography>
      )}

      {requestFilesConfigData && (
        <Grid xs={12} sm={12} md={12} lg={12}>
          <RequestFileDropZone
            fileConfig={requestFilesConfigData}
            files={uploadedFiles}
            setFiles={setUploadedFiles}
            isLoading={false}
          />{' '}
        </Grid>
      )}
    </>
  );
};

export default DocumentUploader;
